'use strict';

angular.module('mean.projects').factory('shortcutService', ['$filter',
    function($filter) {

        //my_bid_tasks === $scope.my_bid_tasks
        var buildMatrixSubtasks = function(my_bid_tasks) {
            var subtasks = [];

            for(var i=0; i<my_bid_tasks.length; i++) {
                for(var j=0; j<my_bid_tasks[i].subtasks.length; j++) {
                    subtasks.push(my_bid_tasks[i].subtasks[j]);
                }
            }

            return subtasks;
        };

        //plans === $scope.matrix_plans
        //subtasks === $scope.matrix_subtasks
        //bid_tasks === $scope.my_bid_tasks
        //my_bid === $scope.my_bid.bid
        var updateShortcuts = function(plans, subtasks, bid_tasks, my_bid) {
            for(var i=0; i<plans.length; i++) {
                for(var j=0; j<subtasks.length; j++) {
                    var task = $filter('filter')(bid_tasks, {
                        'task': subtasks[j].task}, true);

                    if(task.length !== 1) {
                        alert('Did not get the right task when building shortcuts');
                        return;
                    }

                    var bid = $filter('filter')(my_bid, {
                        'plan_code': plans[i].item, 'task_id': task[0]._id}, true);

                    if(!subtasks[j].values) {
                        subtasks[j].values = [];
                    }

                    if(bid.length === 0) {
                        subtasks[j].values.push({
                            plan_code: plans[i].item,
                            quantity: 0
                        });
                    } else {
                        var inlist = $filter('filter')(bid[0].subtasks, {
                            'task_id': subtasks[j]._id}, true);

                        if(inlist.length !== 1) {
                            alert('Something is wrong with the bid not matching with the subtask');
                            return;
                        }

                        subtasks[j].values.push({
                            plan_code: plans[i].item,
                            quantity: inlist[0].quantity
                        });
                    }
                }
            }

            return subtasks;
        };

        return {
            buildMatrixSubtasks: buildMatrixSubtasks,
            updateShortcuts: updateShortcuts
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/trades/public/services/shortcut-service.js